import config from '@/config/index'
// import { getToken } from '@/utils/auth'
import { getToken } from '../utils/auth'
import { Message } from 'element-ui'
export const mainRequests = {
  post,
  get,
  postComplaint,
  getComplaint,
  getRider,
  postRider,
  getComplaintCC,
  postComplaintCC,
  getOutletToken,
  postOutletToken,
  postAdmin,
  alertReporter,
  getDiscount,
  getAllMall,
  postDiscount,
  delDiscount,
  getServices,
  getAllApp
}
function alertReporter (message, type) {
  Message({
    message: message,
    duration: 2500,
    type: type,
    showClose: 1
  })
}
function handleResponseToken (response) {
  return response
    .text()
    .then(text => {
      const data = text && JSON.parse(text)
      if (!response.ok) {
        if (response.status === 401) {
          logout()
          // location.reload(true)
        }
        const error = (data && data.message) || response.statusText
        return Promise.reject(error)
      }

      return data
    })
    .catch(err => {
      return Promise.reject(err)
    })
}
function handleResponse (response) {
  return response
    .text()
    .then(text => {
      const data = text && JSON.parse(text)
      if (!response.ok) {
        if (response.status === 401) {
          //   logout()npm run serve
          location.reload(true)
        }

        const error = (data && data.message) || response.statusText
        return Promise.reject(error)
      }

      return data
    })
    .catch(err => {
      return Promise.reject(err)
    })
}
async function post (url, payload) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      },
      body: JSON.stringify(payload)
    }
    fetch(`${config.BASE_SERVER_MANAGE_PATH}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function postAdmin (url, payload) {
  const promise = new Promise((resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }
    fetch(`${'https://rest.toktok.mn'}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function get (url) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      }
    }
    fetch(`${config.BASE_SERVER_MANAGE_PATH}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function getServices (url) {
  const promise = new Promise((resolve, reject) => {
    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' }
    // }
    fetch(`${config.VUE_APP_MANAGE_SERVICE}` + url)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function postDiscount (url, body) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      },
      body: JSON.stringify(body)
    }
    fetch(`${config.VUE_APP_MANAGE_DISCOUNT_API}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function delDiscount (url) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      }
    }
    fetch(`${config.VUE_APP_MANAGE_DISCOUNT_API}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function getDiscount (url) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      }
    }
    fetch(`${config.VUE_APP_MANAGE_DISCOUNT_API}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function getAllMall (url) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      }
    }
    fetch(`${config.VUE_APP_MANAGE_DISCOUNT_GET_API}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function getAllApp (url) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      }
    }
    fetch(`${config.VUE_APP_MANAGE_DISCOUNT_API}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}

async function postComplaint (url, payload) {
  const promise = new Promise((resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }
    fetch(`${config.COMPLAINT_SERVER}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function postComplaintCC (url, payload) {
  const promise = new Promise((resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }
    fetch(`${config.COMPLAINT_SERVER_CC}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function getComplaint (url) {
  const promise = new Promise((resolve, reject) => {
    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' }
    // }
    fetch(`${config.COMPLAINT_SERVER}` + url)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function getComplaintCC (url) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      }
    }
    fetch(`${config.COMPLAINT_SERVER_CC}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function getRider (url) {
  const promise = new Promise((resolve, reject) => {
    // const requestOptions = {
    //   method: 'POST',
    //   headers: { 'Content-Type': 'application/json' }
    // }
    fetch(`${config.BASE_SERVER_MANAGE_PATH + '/rider'}` + url)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function postRider (url, payload) {
  const promise = new Promise(async (resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${await getToken()}`
      },
      body: JSON.stringify(payload)
    }
    fetch(`${config.BASE_SERVER_MANAGE_PATH + '/rider'}` + url, requestOptions)
      .then(handleResponse)
      .then(data => {
        resolve(data)
      })
      .catch(error => {
        reject(error)
      })
  })
  const result = await promise
  return result
}
async function getOutletToken (url) {
  const promise = new Promise((resolve, reject) => {
    const requestOptions = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer '
      }
    }
    const token = window.localStorage.getItem('token')
    if (token) {
      requestOptions.headers.Authorization = 'Bearer ' + token
      fetch(`${config.BASE_SERVER_MANAGE_PATH}` + url, requestOptions)
        .then(handleResponseToken)
        .then(data => {
          resolve(data)
        })
    } else {
      alert('token awch chadsangvi')
    }
  })
  const result = await promise
  return result
}
async function postOutletToken (url, payload) {
  const promise = new Promise((resolve, reject) => {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // 'Cache-Control': 'no-cache, private, proxy-revalidate',
        Authorization: 'Bearer '
      },
      body: JSON.stringify(payload)
    }
    const token = window.localStorage.getItem('token')
    if (token) {
      requestOptions.headers.Authorization = 'Bearer ' + token
      fetch(`${config.BASE_SERVER_MANAGE_PATH}` + url, requestOptions)
        .then(handleResponseToken)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(error)
        })
    } else {
      alert('token awch chadsangvi', reject)
    }
  })
  const result = await promise
  return result
}

function logout () {
  localStorage.removeItem('loggedOutlet')
  localStorage.removeItem('user')
  localStorage.removeItem('outlet')
  localStorage.removeItem('userType')
  localStorage.removeItem('outletData')
  localStorage.clear()
}
